module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Passage from India: Essays, Poems, and Stories")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch002#about-the-book"
    }
  }, [_vm._v("About the Book")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch003#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch004#copyright-information"
    }
  }, [_vm._v("Copyright Information©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch005#essays"
    }
  }, [_vm._v("Essays")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch005#can-one-be-spiritual-without-being-a-ritualist"
    }
  }, [_vm._v("Can One Be Spiritual Without Being a Ritualist?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch005#mahatma-gandhi-and-the-american-imagination"
    }
  }, [_vm._v("Mahatma Gandhi and the American Imagination")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch005#a-passage-now-from-america-via-south-africa-to-india"
    }
  }, [_vm._v("A Passage Now from America via South Africa to India!")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch005#east-and-west-a-time-to-meet"
    }
  }, [_vm._v("East and West: A Time to Meet")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch005#works-cited"
    }
  }, [_vm._v("Works Cited")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch005#other-related-works-of-interest"
    }
  }, [_vm._v("Other Related Works of Interest")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch005#thoreau-and-emerson-in-india"
    }
  }, [_vm._v("Thoreau and Emerson in India")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch005#section"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch005#prologue"
    }
  }, [_vm._v("Prologue")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch005#the-concept-of-evolutionprogression-past-present-and-future-in-whitmans-passage-to-india"
    }
  }, [_vm._v("The Concept of Evolution/Progression: Past, Present, and Future in Whitman’s ‘Passage to India’")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch005#note"
    }
  }, [_vm._v("Note")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch005#works-cited-1"
    }
  }, [_vm._v("Works Cited")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch005#indian-caste-system-applicability-to-us-indians-in-north-america"
    }
  }, [_vm._v("Indian Caste System – Applicability to Us Indians in North America")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#poems",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poems")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#sacred-and-actual-places",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sacred and Actual Places")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#why-was-she-forced-to-lose-her-long-flowing-dark-hair",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Why Was She Forced to Lose Her Long, Flowing, Dark Hair?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#a-prayer-addressed-to-lord-of-death",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Prayer Addressed to Lord of Death")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#on-first-watching-attenboroughs-gandhi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On First Watching Attenborough’s ‘Gandhi’")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#monkey-army-at-tirumalai-hills-south-india-the-abode-of-lord-venkateswara",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monkey Army at Tirumalai Hills, South India – The Abode of Lord Venkateswara")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#on-first-looking-at-the-lord-of-the-seven-hills",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On First Looking at the Lord of the Seven Hills")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#karma-i",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Karma I")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#karma-ii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Karma II")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#crossing-godavary-river-by-train-in-third-class-compartment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crossing Godavary River by Train in Third-Class Compartment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#walking-by-godavary-river-on-a-rainy-evening",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Walking by Godavary River on a Rainy Evening")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#godavary-river-in-floods",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Godavary River in Floods")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#godavary-river-in-summer",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Godavary River in Summer")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#immutability",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Immutability")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#here-and-there",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Here and There")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#meditation-at-godavary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meditation at Godavary")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#the-path-yet-to-be-made",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Path Yet to Be Made")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#on-looking-at-banyan-tree",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On Looking at Banyan Tree")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#song-of-hope",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Song of Hope")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#my-house-of-hope",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My House of Hope")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#lines-composed-upon-reading-a-line-god-ever-present-divine-principle-is-always-with-us.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lines Composed upon Reading a Line – “God, Ever-Present Divine Principle Is Always with Us.”")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#my-grandfather-died-in-the-holy-city",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Grandfather Died in the Holy City")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#god-vs.-man",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God vs. Man")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#soul",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soul!")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#whats-there-in-name",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What’s There in Name?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#love-and-fear",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love and Fear")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#new-delhi-summer",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Delhi Summer")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#disunity-in-unity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Disunity in Unity")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#self-sufficiency-or-self-reliance",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Self-Sufficiency or Self-Reliance!")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#in-meditation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Meditation")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#who-am-i",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Who Am I?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#passage-from-india",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Passage from India")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#inspired-by-walt-whitmans-passage-to-india",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(Inspired by Walt Whitman’s ‘Passage to India’)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#notes-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#a-hymn-to-agni",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Hymn to Agni")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#my-mother-annapoornamma",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Mother, Annapoornamma!")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#a-hamlet-of-brahmin-widows",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Hamlet of Brahmin Widows")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#sitting-at-home-on-a-sunday-morning-while-my-neighbors-go-to-church",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sitting at Home on a Sunday Morning While My Neighbors Go to Church")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#driving-in-blinding-snowstorm",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Driving in Blinding Snowstorm")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#snow-in-spring",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snow in Spring!!!")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#lift-off-toward-heavens",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lift-Off Toward Heavens")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#the-dark-anniversary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dark Anniversary")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#a-quick-visit-to-the-temple-of-poseidon-by-a-luxury-tourist-bus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Quick Visit to the Temple of Poseidon by a Luxury Tourist Bus")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#sunset-in-mykanos-the-greek-island",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunset in Mykanos, the Greek Island")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#sunset-in-santorini-greek-island",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunset in Santorini, Greek Island")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#the-old-mop-lady-of-building-number-three-moldova-state-university",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Old Mop Lady of Building Number Three, Moldova State University")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#hi-noroc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Hi Noroc!”")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#martishor-to-you-moldova",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Martishor to You, Moldova!")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#the-cats-of-sanaa-yemen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cats of Sanaa, Yemen")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#lines-conceived-upon-an-adventurous-maiden-marathon-qat-chewing-session",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lines Conceived upon an Adventurous Maiden Marathon ‘Qat’-Chewing Session")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#the-man-who-played-lute-upon-chewing-qat-dedicated-to-yahya-annono",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Man Who Played Lute upon Chewing ‘Qat’ (Dedicated to Yahya Annono)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#an-expedition-on-ramadan-evening",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Expedition on Ramadan Evening")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#trip-into-the-past-a-visit-to-rila-monastery-bulgaria",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trip into the Past: A Visit to Rila Monastery, Bulgaria")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#the-memorable-blagoevgrad-rain",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Memorable Blagoevgrad Rain")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#blagoevgrads-bouncing-young-women",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blagoevgrad’s Bouncing Young Women")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#on-rereading-tao-chien",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On Rereading Tao Ch’ien")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#in-the-company-of-the-ancient-chinese-poet-li-po",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the Company of the Ancient Chinese Poet Li Po")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#on-teaching-ancient-chinese-literature-to-western-students",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On Teaching Ancient Chinese Literature to Western Students")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#parting",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parting")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#past-present-and-future",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Past, Present, and Future")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#watching-humming-birds",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Watching Humming Birds")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-81"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#watching-my-daughter-neela-perform-bharata-natyam-south-indian-classical-dance",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Watching My Daughter Neela Perform Bharata Natyam, South Indian Classical Dance")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-82"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#on-growing-old",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On Growing Old!")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-83"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#modern-old-age",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Modern Old Age")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-84"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#my-sacred-body",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Sacred Body")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-85"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#i-stand-tall",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Stand Tall")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-86"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#wither-my-mother-tongue-telugu",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wither My Mother Tongue, Telugu!!!")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-87"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#communion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Communion*")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-88"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch007#stories",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stories")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-89"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch007#grandpa-where-is-he",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grandpa! Where Is He?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-90"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch007#the-homecoming",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Homecoming")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-91"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch007#the-river-of-return",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The River Of Return")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-92"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch007#temple-bells",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Temple Bells")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-93"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch007#embrace",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Embrace")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-94"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch007#a-christmas-gift",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Christmas Gift!!!")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-95"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch007#om-om-om",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OM OM OM")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-96"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch007#gayatri-maha-mantra-chanting-jaap",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gayatri Maha Mantra (Chanting – Jaap)")])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb74dd3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/nav.vue
// module id = 60
// module chunks = 0